const DEFAULT_IDLE_INTERVAL_MS = 30000
const DEFAULT_ACTIVE_INTERVAL_MS = 10000
const MIN_INTERVAL_MS = 5000
const MAX_INTERVAL_MS = 300000

export type AgentTelemetryRuntimeConfig = {
  enabled: boolean
  idleIntervalMs: number
  activeIntervalMs: number
}

let current: AgentTelemetryRuntimeConfig | null = null
const listeners = new Set<() => void>()

export function getAgentTelemetryRuntimeConfig(): AgentTelemetryRuntimeConfig | null {
  return current
}

export function setAgentTelemetryRuntimeConfig(next: {
  enabled?: boolean
  idleIntervalMs?: number
  activeIntervalMs?: number
}): void {
  current = {
    enabled: next.enabled !== false,
    idleIntervalMs: clampInterval(next.idleIntervalMs, DEFAULT_IDLE_INTERVAL_MS),
    activeIntervalMs: clampInterval(next.activeIntervalMs, DEFAULT_ACTIVE_INTERVAL_MS),
  }
  listeners.forEach((listener) => listener())
}

export function subscribeAgentTelemetryRuntimeConfig(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

function clampInterval(value: number | undefined, fallback: number): number {
  if (value == null || !Number.isFinite(value) || value < MIN_INTERVAL_MS) return fallback
  if (value > MAX_INTERVAL_MS) return MAX_INTERVAL_MS
  return Math.round(value)
}
